Ext.define('SA.ViewController2', {
    constructor(model) {
        this.model = model;
        this.modeStates = new SA.ModeStates();
    },

    deactivate() {
        this.modeStates.deactivate();
    },

    getModel() {
        return this.model;
    },

    switchMode() {
        this.modeStates.switchMode();
    }
});